import React from 'react';
import {
  HistoryItemContainer,
  Title,
  DateBlock,
} from './styles';
import { formatDate } from '../utils/format-date';
import { useIntl } from 'react-intl';

interface HistoryItemProps {
  title: string;
  date: string;
}

export const HistoryItem = ({ title, date }: HistoryItemProps): JSX.Element => {
  // The provider's locale — the one the copy around this date is rendered in. Never the building's: two
  // locale sources on one screen put French words beside an English date.
  const { locale } = useIntl();

  return (
    <HistoryItemContainer>
      <Title>{title}</Title>
      <DateBlock>{formatDate(date, locale)}</DateBlock>
    </HistoryItemContainer>
  );
};
